import {RelationSubject} from "../../modules/tasks/enums/RelationSubject";
import {deserializePatient, Patient} from "../Patient";
import {deserializeMedium, Medium} from "../Medium";
import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../Helpers";
import {RelationType} from "../../modules/tasks/enums/RelationType";
import {WorkStatus} from "../../modules/tasks/enums/WorkStatus";
import {Task} from "../Task";
import {deserializeEcgMeasurementWithPatient} from "../patient/measurement/ECG";
import {deserializeTaskRelationResource, TaskRelationResource} from "./relation/Resource";
import {deserializePatientTriggerEvent, PatientTriggerEvent} from "../trigger/PatientTriggerEvent";

export type SubjectType = Patient | Medium | Task | PatientTriggerEvent | DeserializedRecord;

interface TaskRelation extends DeserializedRecord {
  comment: string,
  relationType: RelationType,
  subjectType: RelationSubject,
  workStatus: WorkStatus,
  subjectId: string,
  subjectTitle: string,
  task: Task,
  subject: SubjectType,
  taskRelationResources: TaskRelationResource[]
  taskRelationResourcesAttributes: TaskRelationResource[]
}

interface TaskRelationData extends JSONAPIRecord {
  relationships: {
    task: JSONAPISingleRelationship;
    subject: JSONAPISingleRelationship;
    resource: JSONAPISingleRelationship;
    task_relation_resources: JSONAPIManyRelationship;
  }
}

const deserializerBySubjectType = (subjectType: RelationSubject) => {
  switch (subjectType) {
    case RelationSubject.Patient:
      return deserializePatient;
    case RelationSubject.PatientTriggerEvent:
      return deserializePatientTriggerEvent;
    case RelationSubject.Medium:
      return deserializeMedium;
    case RelationSubject.Ecg:
      return deserializeEcgMeasurementWithPatient;
    default:
      return deserializeItem;
  }
};

const deserializeTaskRelation: Deserializer<TaskRelation, TaskRelationData> = (data, included) => {
  const task =  deserializeSingleRelationship<Task>(data.relationships.task, included);
  const attributes = deserializeItem<TaskRelation>(data);

  const subject = deserializeSingleRelationship<SubjectType>(
    data.relationships.subject,
    included,
    deserializerBySubjectType(attributes.subjectType)
  );

  const taskRelationResources = deserializeManyRelationship<TaskRelationResource>(
    data.relationships.task_relation_resources,
    included,
    deserializeTaskRelationResource);

  return {
    ...attributes,
    subject,
    task,
    taskRelationResources,
    taskRelationResourcesAttributes: taskRelationResources
  };
};

export {
  deserializeTaskRelation, TaskRelation
};
